import type {
  AccountlessNatalieEventApiResponse,
  NatalieEventDetail,
  NatalieEventDetailData,
  NatalieEventPublicDetail,
  NatalieEventPublicDetailData,
} from './natalieEvent.types';

export const mapNataliePublicEventDetailFromApi = (data: NatalieEventPublicDetailData): NatalieEventPublicDetail => ({
  id: data.id,
  communityId: data.communityId,
  endDate: data.endDate,
  name: data.name,
  topic: data.topic,
  description: data.description ?? null,
  ownerName: data.ownerName,
  communityName: data.communityName ?? '',
  status: data.status,
  logoImageLink: data.logoImageLink ?? null,
  videoUrl: data.videoUrl ?? null,
  durationInMinutes: data.sessionDurationMinutes ?? 0,
});

export const mapNatalieEventDetailFromApi = (data: NatalieEventDetailData): NatalieEventDetail => ({
  id: data.id,
  communityId: data.communityId,
  endDate: data.endDate,
  name: data.name,
  topic: data.topic,
  description: data.description ?? null,
  ownerName: data.ownerName,
  communityName: data.communityName ?? '',
  status: data.status,
  logoImageLink: data.logoImageLink ?? null,
  videoUrl: data.videoUrl ?? null,
  durationInMinutes: data.sessionDurationMinutes ?? 0,
});

export const mapAccountlessEventFromApi = (data: AccountlessNatalieEventApiResponse): NatalieEventPublicDetail => ({
  id: data.id,
  communityId: '',
  endDate: data.endDate,
  name: data.name,
  topic: data.topic,
  description: data.description ?? null,
  ownerName: data.ownerName ?? '',
  communityName: data.communityName ?? '',
  status: data.status,
  durationInMinutes: data.sessionDurationMinutes ?? 0,
  logoImageLink: data.logoImageLink ?? null,
  videoUrl: null,
});
